import { TextAreaFormGroupField } from '@frontend/components/fields/TextAreaField';
import { translateKey } from '@frontend/translate';
import { renameErrorKeys } from '@frontend/utils/renameErrorKeys';
import type { ICustomControlProcedureDiagnosticReportAddEditProps } from '../../interfaces';
import { FormContextProvider } from '../../../../elements/formContext';
import { BooleanRadioGroupFormGroupField } from '../../../../fields/BooleanRadioGroupField';
import { NewOrEditDiagnosticReportProcessContainer } from '../../utils/v1/NewOrEditDiagnosticReportProcessContainer';
import { DiagnosticReportAfwijkingenAddEdit } from './components/DiagnosticReportAfwijkingenAddEdit';
import { defaultBooleanRadioGroupFormGroupFieldProps, defaultTextAreaFormGroupFieldProps } from './types';

export function OorkV1DiagnosticReportAddEdit(props: ICustomControlProcedureDiagnosticReportAddEditProps) {
    const customControlData = props.diagnosticReport.customControlData;

    return (
        <NewOrEditDiagnosticReportProcessContainer
            currentDiagnosticReport={props.currentDiagnosticReport}
            itemState={props.itemState}
            process={props.process}
            service={props.service}
            title={translateKey('diagnosticReport.findings')}
        >
            <FormContextProvider
                value={{
                    placeholderGroupName: 'diagnosticReport',
                    item: customControlData,
                    errors: renameErrorKeys(props.errors, 'diagnosticReport.customControlData', 'customControlData'),
                    customControlData: true,
                    onChange: (key, value) => props.handleChangeCustomControlDiagnosticReport({ [key]: value }),
                    onDoValidate: async (key) => await props.validateOneCustomControlDiagnosticReport(key),
                }}
            >
                <DiagnosticReportAfwijkingenAddEdit
                    customControlData={customControlData}
                    errors={props.errors}
                    handleChangeCustomControl={props.handleChangeCustomControlDiagnosticReport}
                    isRequired={true}
                    validateOneCustomControl={(value) => props.validateOneCustomControlDiagnosticReport(value)}
                />

                <BooleanRadioGroupFormGroupField
                    {...defaultBooleanRadioGroupFormGroupFieldProps}
                    fieldKey="relevante_comorbiditeit"
                    isRequired={true}
                    label="Relevante comorbiditeit in relatie tot de rijgeschiktheid"
                    onChange={async (value) => {
                        if (customControlData.relevante_comorbiditeit) {
                            await props.handleChangeCustomControlDiagnosticReport({
                                toelichting_relevante_comorbiditeit: null,
                            });
                        }
                        await props.handleChangeCustomControlDiagnosticReport({ relevante_comorbiditeit: value });
                    }}
                />

                {customControlData.relevante_comorbiditeit && (
                    <TextAreaFormGroupField
                        {...defaultTextAreaFormGroupFieldProps}
                        fieldKey="toelichting_relevante_comorbiditeit"
                        label="Toelichting relevante comorbiditeit"
                        placeholder="Toelichting relevante comorbiditeit..."
                    />
                )}

                <TextAreaFormGroupField
                    {...defaultTextAreaFormGroupFieldProps}
                    fieldKey="aanvullende_informatie"
                    label="Aanvullende informatie"
                    placeholder="Optioneel aanvullende informatie..."
                />
            </FormContextProvider>
        </NewOrEditDiagnosticReportProcessContainer>
    );
}
